import React from 'react';

// contains all recommendations for merchanthub
const MyRecommendations = () => (
  <div id="recommendations" style={{ visibility: 'hidden', height: 0 }}>
    {/* put empty recommendation divs here */}
  </div>
);

export default MyRecommendations;
